import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { IBasePopupModel } from '../../models/popup.model';

@Component({
    selector: 'app-base-popup',
    standalone: false,
    template: '',
})
export abstract class BasePopupComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: IBasePopupModel,
        protected dialogRef: MatDialogRef<BasePopupComponent>,
    ) {}

    static getDialogConfig(): MatDialogConfig<IBasePopupModel> {
        return {
            data: {},
            backdropClass: 'blurred-backdrop',
        };
    }

    @HostListener('window:resize')
    onResize(): void {
        this.adjustPopupSize();
    }

    ngOnInit(): void {
        this.adjustPopupSize();
    }

    protected onCancel(): void {
        this.dialogRef.close(false);
    }

    protected onOkay(): void {
        this.dialogRef.close(true);
    }

    private adjustPopupSize(): void {
        const isMobile = window.innerWidth <= 768;
        this.dialogRef.updateSize(isMobile ? '90vw' : '768px');
    }
}
